<template>
  <div :class="`result-path ${resultType}-type`">
    <div class="result-inner">
      <div :style=" { left: adjustedPathTop  + 'px' }" class="type-dot top">
        <svg fill="none" height="12" viewBox="0 0 12 12" width="12"
             xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_i_26_5033)">
            <ellipse :fill="`${resultType === 'a'? '#B6DC92' :'#80DAEB'}`" cx="6" cy="6" rx="6" ry="6"
                     transform="rotate(90 6 6)" />
          </g>
          <defs>
            <filter id="filter0_i_26_5033" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse" height="14"
                    width="12" x="0"
                    y="0">
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
              <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix"
                             values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0" />
              <feBlend in2="shape" mode="normal" result="effect1_innerShadow_26_5033" />
            </filter>
          </defs>
        </svg>
      </div>
      <div :style=" { left: pathTop + 'px' }" class="type-result">
        <svg :viewBox="`0 0 ${pathWidth} ${pathHeight}`" fill="none"
             height="60"
             xmlns="http://www.w3.org/2000/svg">
          <path :d="pathValue"
                :stroke="`${resultType === 'a'? '#006200' :'#065B62'}`"
                stroke-linecap="round"
                stroke-width="4" />

        </svg>

      </div>
      <div :style="{ left: adjustedPathBottom + 'px' }" class="type-dot btm">
        <svg fill="none" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_i_26_5033)">
            <ellipse :fill="`${resultType === 'a'? '#B6DC92' :'#80DAEB'}`" cx="6" cy="6" rx="6" ry="6"
                     transform="rotate(90 6 6)" />
          </g>
          <defs>
            <filter id="filter0_i_26_5033" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse" height="14"
                    width="12" x="0"
                    y="0">
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
              <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix"
                             values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0" />
              <feBlend in2="shape" mode="normal" result="effect1_innerShadow_26_5033" />
            </filter>
          </defs>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'ABreportResultPath',
  props: ['pathTop', 'pathBottom', 'resultType', 'pathValue', 'pathWidth',
    'pathHeight'],
  data () {
    return {
      adjustedPathTop: 0,
      adjustedPathBottom: 0
    }
  },
  watch: {
    pathTop (val) {
      this.setAdjustedPathTop()
    },
    pathBottom (val) {
      this.setAdjustedPathBottom()
    }
  },
  mounted () {
    this.setAdjustedPathTop()
    this.setAdjustedPathBottom()
    window.addEventListener('resize', this.setAdjustedPathTop)
    window.addEventListener('resize', this.setAdjustedPathBottom)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setAdjustedPathTop)
    window.removeEventListener('resize', this.setAdjustedPathBottom)
  },
  methods: {
    setAdjustedPathTop () {
      const offset = window.innerWidth >= 2000 ? 2 : 4
      this.adjustedPathTop = this.pathTop - offset
    },
    setAdjustedPathBottom () {
      let offset
      if (window.innerWidth <= 1100) {
        offset = 5
      } else if (window.innerWidth >= 2000) {
        offset = 1
      } else {
        offset = 3
      }
      this.adjustedPathBottom = this.pathBottom - offset
    }
  }

}
</script>
<style lang="scss" scoped>
.result-path {
  max-width: 312px;;
  width: 100%;
  position: absolute;
  bottom: 15px;

  z-index: 1;

  &.b-type {
    right: 0;

    .result-inner {
      transform: scaleX(-1);
      right: 0;
    }
  }

}

.result-inner {
  position: absolute;
  z-index: 10;

  .type-result {
    position: relative;

  }

  .type-dot {
    position: absolute;
    z-index: -1;

    &.top {

      top: -4px;
    }

    &.btm {

      bottom: -4px;
    }
  }
}
</style>
